export const RESET = 'state.domain.issue-goals.RESET' as const;

export type ResetAction = {
	type: typeof RESET;
	payload: string[];
};

export const reset = (payload: string[]): ResetAction => ({
	type: RESET,
	payload,
});
